import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import CalendarView from "../views/CalendarView"
import InspectionHistoryView from "../views/InspectionHistoryView"
import EExpertView from "../views/EExpertView"

const Sidebar = ({
  inspectionHistory,
  loading,
  showEExpert,
  inspectionId,
  onCloseEExpert,
  appLookups,
  sessionId,
  onFileUpload,
  refreshInspectionDetails,
  isDynamic,
  setLoading
}) => {
  const location = useLocation()
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1200)

  // Check window width on mount and resize
  useEffect(() => {
    const handleResize = () => {
      const wideScreen = window.innerWidth > 1200
      setIsWideScreen(wideScreen)

      // Reset fullscreen state when going to wide screen
      if (wideScreen && isFullscreen) {
        setIsFullscreen(false)
      }
    }

    // Set initial value
    handleResize()

    // Add resize listener
    window.addEventListener("resize", handleResize)

    // Clean up
    return () => window.removeEventListener("resize", handleResize)
  }, [isFullscreen])

  // Toggle fullscreen state
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
  }

  // Determine which component to render based on the route and showEExpert flag
  const renderContent = () => {
    // If we're showing e-expert iframe
    if (showEExpert && (inspectionId || location.pathname.includes("/dynamic-inspection"))) {
      return (
        <EExpertView
          inspectionId={inspectionId}
          sessionId={sessionId}
          onClose={onCloseEExpert}
          appLookups={appLookups}
          onFileUpload={onFileUpload}
          refreshInspectionDetails={refreshInspectionDetails}
          isDynamic={isDynamic}
          setLoading={setLoading}
        />
      )
    }

    // Check if we're on an inspection details page
    if (location.pathname.includes("/inspections/") && !location.pathname.endsWith("/inspections/")) {
      return <InspectionHistoryView history={inspectionHistory} loading={loading} />
    }
    // Default to calendar view
    return <CalendarView />
  }

  return (
    <div className={`sidebar h-100 overflow-auto ${isFullscreen ? "sidebar-fullscreen" : ""}`}>
      {!isWideScreen && (
        <button
          className="btn btn-sm fullscreen-toggle"
          onClick={toggleFullscreen}
          aria-label={isFullscreen ? "Minimize sidebar" : "Maximize sidebar"}>
          <i className={`fa ${isFullscreen ? "fa-arrow-down" : "fa-arrow-up"}`}></i>
        </button>
      )}
      {renderContent()}
    </div>
  )
}

export default Sidebar
